import React, {useState, useEffect} from 'react'

import classes from './Qrl.module.css'
import AppState from '@/js/AppState';
import { QRL } from 'react-sdk/activities/QRL';
import { observer } from 'mobx-react-lite';
import Clues from './Clues/Clues';
import Button from '@/components/shared/Button/Button';
import Texts from 'react-sdk/Texts';

/**
* @param {object} props
* @param {QRL} props.instance
*/
const Qrl = ({instance, onReadyToValidate}) => {


  useEffect(() => {
    onReadyToValidate(instance.userInput.length > 0)
  }, [instance.userInput]);

  return (
    <div className={classes.Qrl}>

      

      {!instance.result &&
      <div className={classes.game}>
        <div className={classes.clues}>
          <Clues clues={instance.userClues} instance={instance}  />
        </div>
        <div className={classes.user_input} >
          <input
          type="text"
          autoFocus
          value={instance.userInput}
          onChange={e =>{
            console.log("e.target.value", e.target.value)
            instance.userInput = e.target.value
          }} />
        </div>

      </div>}

      {instance.result &&
      <div className={classes.correction}>
        {Texts.get("qrl-good-answer-is", {fallback: "La bonne réponse est"})}  <strong>{instance.result.additionalInfos?.correctWord}</strong>
      </div>}
    </div>
  );
};

export default observer(Qrl)
